import { FileText, MessageCircle, Tv2Icon, UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

import AgreementsIcon from '../images/icons/agreements.svg?react';
import ApiIntegration from '../images/icons/api-integration.svg?react';

export const contactsSubNav: RouteListItem[] = [
  {
    path: '/contacts/$id',
    icon: UserCircle,
    name: 'Contact',
    auditKey: 'contacts/profile',
  },
  {
    path: '/contacts/$id/api-integration',
    icon: ApiIntegration,
    name: 'API Integrations',
    auditKey: 'contacts/api-integration',
  },
  {
    path: '/contacts/$id/agreements',
    icon: AgreementsIcon,
    name: 'Agreements',
    auditKey: 'contacts/agreements',
  },
  {
    path: '/contacts/$id/marketing-campaigns',
    icon: Tv2Icon,
    name: 'Marketing Campaigns',
    auditKey: 'contacts/marketing-campaigns',
  },
  {
    path: '/contacts/$id/support',
    icon: MessageCircle,
    name: 'Support',
    auditKey: 'contacts/support',
    isDisabled: false,
    isDoubleNested: true,
  },
  {
    path: '/contacts/$id/notes',
    icon: FileText,
    name: 'Notes',
    auditKey: 'contact/notes',
    isDisabled: false,
  },
];
